import {
  bookmarksPath,
  connectionsFullPagePath,
  memberProfileModalPathsWithState,
} from "@circle-react/helpers/urlHelpers";
import type { PathWithState } from "@circle-react/helpers/urlHelpers/memberProfileModalPaths";

import { t } from "@/i18n-js/instance";

import { DrawerMenuItem } from "../components/DrawerMenuItem";
import { NestedDrawerMenuItem } from "../components/NestedDrawerMenuItem";
import { MobileChatThreadsDrawerContent } from "../MobileChatThreadsDrawerContent";
import { MobileMemberChecklistDrawerContent } from "../MobileMemberChecklistDrawerContent";

interface ProfileActionsSectionProps {
  closeAll: () => void;
  handleMemberChecklistOpenChange: (open: boolean) => void;
  isConnectEnabled: boolean;
  isMemberChecklistOpen: boolean;
  isThreadsOpen: boolean;
  location: { pathname: string; search: string };
  navigateAndClose: (path: string | PathWithState) => void;
  setIsThreadsOpen: (open: boolean) => void;
  shouldShowMemberChecklist: boolean;
}

/**
 * Nav drawer's "Profile actions" section.
 */
export const ProfileActionsSection = ({
  isThreadsOpen,
  setIsThreadsOpen,
  isConnectEnabled,
  shouldShowMemberChecklist,
  isMemberChecklistOpen,
  handleMemberChecklistOpenChange,
  closeAll,
  navigateAndClose,
  location,
}: ProfileActionsSectionProps) => (
  <div className="flex flex-col gap-0.5">
    <NestedDrawerMenuItem
      icon="message-dots"
      label={t("header_v3.chat_threads")}
      ariaLabel={t("header_v3.chat_threads")}
      open={isThreadsOpen}
      onOpenChange={setIsThreadsOpen}
    >
      <MobileChatThreadsDrawerContent />
    </NestedDrawerMenuItem>
    <DrawerMenuItem
      icon="bookmark"
      label={t("header_v3.bookmarks")}
      onClick={() => navigateAndClose(bookmarksPath())}
    />
    {isConnectEnabled && (
      <DrawerMenuItem
        icon="people"
        label={t("header_v3.connect.title")}
        onClick={() => navigateAndClose(connectionsFullPagePath())}
      />
    )}
    {shouldShowMemberChecklist && (
      <NestedDrawerMenuItem
        icon="to-do-list"
        label={t("header.member_checklist.title")}
        ariaLabel={t("header.member_checklist.title")}
        open={isMemberChecklistOpen}
        onOpenChange={handleMemberChecklistOpenChange}
      >
        <MobileMemberChecklistDrawerContent
          enabled={isMemberChecklistOpen}
          onClose={closeAll}
        />
      </NestedDrawerMenuItem>
    )}
    <DrawerMenuItem
      icon="settings-slider-three"
      label={t("mobile_shell.account_settings")}
      onClick={() =>
        navigateAndClose(memberProfileModalPathsWithState.profile(location))
      }
    />
  </div>
);
